// NPM Imports
import React from "react";

// Component Imports
import Activity from "./Activity";
import ActivityUpgrade from "./ActivityUpgrade";
import { FeatureGating } from "../../commonComponents";

// Internal Imports
import { FEATURES } from "../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.DOCUMENT_ACTIVITY}
      altComponent={
        <ActivityUpgrade
          {...props}
          featureName={FEATURES_NAME.DOCUMENT_ACTIVITY}
        />
      }>
      <Activity {...props} />
    </FeatureGating>
  );
}
